/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
const generateSearchQuery = ({
  filter, currentPage = 1, perPage = 10, url,
}) => {
  const transformParamsKeys = Object.entries(filter).reduce((prev, current) => ({ ...prev, [current[0].charAt(0).toUpperCase() + current[0].substr(1)]: current[1] }), {})
  const filterParams = Object.entries(transformParamsKeys).reduce((memo, [key, value]) => ((value === '' || value === null) ? memo : (memo[key] = value, memo)), {})
  const params = new URLSearchParams(filterParams).toString()
  let searchURL

  if (!Object.keys(filterParams).length) {
    searchURL = `${url}?PageNumber=${currentPage}&PageSize=${perPage}`
  } else if (currentPage !== '' || null) {
    searchURL = `${url}?PageNumber=${currentPage}&PageSize=${perPage}&${params}`
  } else {
    searchURL = `${url}?${params}`
  }
  return searchURL
}

export default generateSearchQuery
